import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const ChevronDownIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill="none"
    viewBox="0 0 16 17"
  >
    <path
      stroke={theme.colors[color]}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={16}
      strokeWidth={1.5}
      d="m4 6.818 4 4 4-4"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
ChevronDownIcon.id = 'ChevronDownIcon';
ChevronDownIcon.displayName = 'ChevronDownIcon';
export default ChevronDownIcon;
